// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-list[data-v-433278a8]{height:calc(100% - 105px);margin:0;overflow:auto;padding-bottom:30px}.menu-list[data-v-433278a8]::-webkit-scrollbar{display:none}.menu-list__title[data-v-433278a8]{font-size:20px;font-weight:600;margin-bottom:20px}.menu-list__item[data-v-433278a8]:not(:last-child){margin-bottom:37px}.Novikov .menu-list__title[data-v-433278a8]{color:#0a0a0a}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
